/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductionSitesForBrandsQueryResponse,
  FindProductionSitesForBrandsQueryParams,
} from "../types/FindProductionSitesForBrands.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductionSitesForBrandsQueryKey = (
  params: FindProductionSitesForBrandsQueryParams
) =>
  [
    { url: "/v1/production-site/find-production-sites-for-brands" },
    ...(params ? [params] : []),
  ] as const

export type FindProductionSitesForBrandsQueryKey = ReturnType<
  typeof findProductionSitesForBrandsQueryKey
>

/**
 * @summary Find production sites for a brand
 * {@link /v1/production-site/find-production-sites-for-brands}
 */
export async function findProductionSitesForBrands(
  params: FindProductionSitesForBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSitesForBrandsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-production-sites-for-brands`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductionSitesForBrandsQueryOptions(
  params: FindProductionSitesForBrandsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductionSitesForBrandsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductionSitesForBrandsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSitesForBrandsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductionSitesForBrands(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find production sites for a brand
 * {@link /v1/production-site/find-production-sites-for-brands}
 */
export function useFindProductionSitesForBrands<
  TData = ResponseConfig<FindProductionSitesForBrandsQueryResponse>,
  TQueryData = ResponseConfig<FindProductionSitesForBrandsQueryResponse>,
  TQueryKey extends QueryKey = FindProductionSitesForBrandsQueryKey,
>(
  params: FindProductionSitesForBrandsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSitesForBrandsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductionSitesForBrandsQueryKey(params)

  const query = useQuery(
    {
      ...findProductionSitesForBrandsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
